module.exports = __webpack_public_path__ + "img/france-digestive-diseases-female.5dcc4d64.png";